// angular
// 	.module("HeroPRO")
// 	.controller("SSOController", SSOController);

import './sso.scss';

/* @ngInject */
export default function SSOController(PartnerAppsFactory, $window, $stateParams) {
    init();

    function init() {
        PartnerAppsFactory.getReportLink($stateParams.destination).then((link) => {
            $window.location.href = link;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/topNav/ssoController.js